export default __webpack_public_path__ + "static/media/bw_photos_tuscany-4.c7c14c56.jpg";